
import { useState, useEffect } from 'preact/hooks';
import style from './style';
import Modal from '../modal/Modal';

const TimelineLink = props => {
    const [showModal, setShowModal] = useState(false);
    const linkType = props.video && style['link-video--'+props.site] ? style['link-video--'+props.site] : '';
    const opened = showModal ? (props.video ? style['link-opened-video--' + props.site] : style['link-opened--' + props.site]) : '';
    const setProp = (prop) => {return props.openedLink = prop};

    useEffect(() => {
        setProp(showModal);
    }, [showModal]);
    return (
        <>
            <span
                class={`${style['link']} ${style[`link--${props.site}`]} ${linkType} ${opened}`}
                onClick={() => setShowModal(!showModal)}
                >
                {props.children}
            </span>
            {
                showModal && (
                    <Modal
                        setShowModal={setShowModal}
                        site={props.site}
                        content={props.content}
                        video={props.video}
                    />)
            }
        </>
    )
}

export default TimelineLink;
